var map = {
	"./areas/bdp/bdp.module": [
		"./src/app/areas/bdp/bdp.module.ts",
		"areas-bdp-bdp-module~views-activiti-activiti-module",
		"areas-bdp-bdp-module"
	],
	"./areas/cms/cms.module": [
		"./src/app/areas/cms/cms.module.ts",
		"areas-cms-cms-module"
	],
	"./areas/kms/kms.module": [
		"./src/app/areas/kms/kms.module.ts",
		"areas-kms-kms-module"
	],
	"./areas/se/se.module": [
		"./src/app/areas/se/se.module.ts",
		"areas-se-se-module"
	],
	"./views/activiti/activiti.module": [
		"./src/app/areas/bdp/views/activiti/activiti.module.ts",
		"areas-bdp-bdp-module~views-activiti-activiti-module",
		"views-activiti-activiti-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;